import setupShopifyAddToCartHook from './hook';
import { isNoProduct } from '../../utils';

export default function productPageInjector() {
  if (isNoProduct()) {
    return;
  }
  setupShopifyAddToCartHook();
}
